import ShopArticleTaxHistoryResourceModel from '../../generated/types/model/resource/ShopArticleTaxHistoryResourceModel';

export default class ShopArticleTaxHistoryResourceViewModel extends ShopArticleTaxHistoryResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
